import React, { Component } from 'react';
import './zipupload.css';
import { Loader, Modal, Progress, Popup } from 'semantic-ui-react'
import { Button, Select, Switch, message } from 'antd'
import axios from 'axios'
import { AutoSizer, Column, Table } from 'react-virtualized'
import 'react-virtualized/styles.css';
import ZipTableModal from './ZipTableModal'

const Option = Select.Option;

const tableStyles = {
  borderStyle: 'solid',
  borderWidth: '3px',
  borderColor: 'black'
}

const headerStyle = {
  textTransform: 'none'
}

const evenRowStyle = {
  background: '#ececec',
  borderBottom: '1px solid #4c4c4c'
}

const oddRowStyle = {
  background: 'white',
  borderBottom: '1px solid #4c4c4c'
}

class Ziptable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectedZip: 0,
      currentSelectedZipFileQueue: [],
      currentSelectedZipFileData: [],
      openConfirmBox: false,
      showLoader: false,
      showModal: false,
      dataInsideModal: [],
      showFillDownProgress: false,
      totalProgressBar: 0,
      updateProgressBar: 0
    }

    this.updateCurZip = this.updateCurZip.bind(this)
    this.openCloseConfirm = this.openCloseConfirm.bind(this)
    this.updateCurZipLoader = this.updateCurZipLoader.bind(this)
    this.closeEditModal = this.closeEditModal.bind(this)
    this.translateValue = this.translateValue.bind(this)
    this.applyFillDown = this.applyFillDown.bind(this)
  }

  componentWillMount() {
    var self = this;
    console.log(self.props)
    if (self.props.insertedZipRow > 0) {
      self.setState({currentSelectedZip: self.props.insertedZipRow})

      axios.get('/api/getSelectMerchUploadQueue', {
        params: {
          id: self.props.insertedZipRow
        }
        }).then(function(results) {
        self.setState({currentSelectedZipFileQueue: results.data})
      })

      axios.get('/api/getSelectMerchZipFiles', {
        params: {
          id: self.props.insertedZipRow
        }
        }).then(function(results) {
          self.setState({currentSelectedZipFileData: results.data})
      })
    }
  }

  openCloseConfirm(){
    if (this.state.openConfirmBox === false) {
      this.setState({openConfirmBox: true})
    } else {this.setState({openConfirmBox: false})}
  }

  changeDescription(e, {...props}) {
    var switchID
    var switchValue
    var errors = 0
    var dataInsideModal = this.state.dataInsideModal

    if(e.target.id !== "") {

      switchID = e.target.id
      switchValue = e.target.value
      if (switchID === 'uploadIndField') {
        if (switchValue !== '0' && switchValue !== '1') {
          alert("Upload Indicator can only by 1 or 0!");
          errors = 1
        }
      }

      if (errors === 0) {
        let index = switchID.indexOf("Field");
        let id = (switchID.substring(0, index));
        dataInsideModal[id] = switchValue

      }

      console.log(dataInsideModal)
    } else {

      switchID = {...props}.id
      switchValue = {...props}.value

      //console.log(switchValue)

      if (switchID === "shirttype_idField") {
        switch(switchValue){ //eslint-disable-line
          case 1:
            dataInsideModal.listprice = '11.54';
            break;
          case 2:
            dataInsideModal.listprice = '13.31';
            break;
          case 3:
            dataInsideModal.listprice = '20.60';
            break;
        }
      }

      let index = switchID.indexOf("Field");
      let id2 = (switchID.substring(0, index));
      dataInsideModal[id2] = switchValue
    }

    this.setState({dataInsideModal: dataInsideModal});

  }

  updateCurZipLoader = (e) => {
    console.log(e)
    this.updateCurZip(e)
    this.setState({currentSelectedZip: e});
  }

  async updateCurZip(value) {
    var self = this;
    var resultsOne
    var resultsTwo
    self.setState({showLoader: true})
    await axios.get('/api/getSelectMerchUploadQueue', {
      params: {
        id: value
      }
      }).then(function(results) {
        resultsOne = results.data
    })
    await axios.get('/api/getSelectMerchZipFiles', {
      params: {
        id: value
      }
      }).then(function(results) {
        resultsTwo = results.data
    })
    self.setState({currentSelectedZipFileQueue: resultsOne, currentSelectedZipFileData: resultsTwo})
    self.setState({showLoader: false})
  }

  translateValue({...props}) {
    var holdText;
    switch({...props}.dataKey) { //eslint-disable-line
      case "shirttype_id":
        this.props.productTypeOptions.forEach(function(value, i){
          if (value.value === {...props}.rowData.shirttype_id) {
            holdText = value.text
            return true
          }
        })
        return holdText
      case "merchtemplatetheme_id":
        this.props.templateThemeOptions.forEach(function(value, i){
          if (value.value === {...props}.rowData.merchtemplatetheme_id) {
            holdText = value.text
          }
        })
        return holdText
      case "merchcalendar_id":
        this.props.eventOptions.forEach(function(value, i){
          if (value.value === {...props}.rowData.merchcalendar_id) {
            holdText = value.text
          }
        })
        return holdText
      case "merchdesigner_id":
        this.props.designerOptions.forEach(function(value, i){
          if (value.value === {...props}.rowData.merchdesigner_id) {
            holdText = value.text
          }
        })
        return holdText
    }
  }

  checkTitleLength({...props}) {
    //console.log({...props})
    var text = {...props}.cellData
    var cutoffText = ({...props}.cellData.substring(0,60) + "...")
    var cellReturn
    if (text.length > 60) {
      cellReturn = <div>
        <Popup
        trigger={<div style={{color: 'red'}}>{cutoffText}</div>}
        content={text}
        header="Full length title"
        />
      </div>
    } else {
      cellReturn = <div>{text}</div>
    }

    return cellReturn
  }

  closeEditModal(){
    this.setState({showModal: false,  dataInsideModal: {}})
  }

  bottomRowClick({...props}) {
    //console.log({...props}.rowData)
    this.setState({showModal: true, dataInsideModal: {...props}.rowData})
  }

  topRowClick({...props}) {
    //console.log({...props}.rowData)
    this.setState({showModal: true, dataInsideModal: {...props}.rowData})
  }

  deleteZipFile = () => {
    console.log(this.state.currentSelectedZipFileData[0])
    axios.post('/removeFile', {
        zipName: this.state.currentSelectedZipFileData[0].zipfile,
        zipid: this.state.currentSelectedZipFileData[0].id
    })
    .then(function(results) { //eslint-disable-line
      if (results.data === "failed") {
        alert("Zip file failed to insert into the database...\nTry again later...")
      }
      //console.log(results);
    })

    message.info('Row deleted!');
    this.setState({currentSelectedZip: 0, currentSelectedZipFileQueue: [], currentSelectedZipFileData: []})

    this.props.getAllZipData()
  }

  async applyFillDown(field){

    var buildMultiInsertObject = {merchzipfiles_id: this.state.currentSelectedZipFileData[0].id, [field]: this.state.currentSelectedZipFileData[0][field]}

    //console.log(buildMultiInsertObject)
    await axios.post('/api/updateMassZipContents', {
        buildInsertObject: buildMultiInsertObject
    })

    .then(function(results) { //eslint-disable-line
      if (results.data === "failed") {
        alert("Zip file failed to insert into the database...\nTry again later...")
      }
      //console.log(results);
    })

    this.closeEditModal()
    this.updateCurZip(this.state.currentSelectedZipFileData[0].id)
  }

  changeRowClass({ index }) {
    if (index < 0) {
      return headerStyle
    }
    return index % 2 === 0 ? evenRowStyle : oddRowStyle
  }

  render() {
    const { currentSelectedZipFileQueue, showModal, dataInsideModal, currentSelectedZipFileData } = this.state
    //console.log(currentSelectedZipFileData, currentSelectedZipFileQueue)


    if (this.props.fileUploading === 1) {
      var showProgress = <Progress percent={this.props.fileUploading} active autoSuccess style={{position: 'relative', width: '25%', top: '-45px', left: '170px'}}>Uploading Zip File...</Progress>
    } else { var showProgress }

    if (this.state.currentSelectedZip > 0) {
      var curZip = this.state.currentSelectedZip
    } else {var curZip} //eslint-disable-line
    var numRows = currentSelectedZipFileQueue.length
    var numRowsTwo = currentSelectedZipFileData.length
    if (this.state.totalProgressBar > 0) {
      var showModalProgress = <Modal open={this.state.showFillDownProgress} dimmer={false}>
          <Modal.Content>
            <Progress value={this.state.updateProgressBar} total={this.state.totalProgressBar} progress='ratio' color='blue' active>
              Updating all current zip files...
            </Progress>
          </Modal.Content>
        </Modal>;
    } else { var showModalProgress }
    if (dataInsideModal.id !== undefined) {
      var renderModal = <ZipTableModal dataInsideModal={dataInsideModal} closeEditModal={this.closeEditModal} showModal={showModal} productTypeOptions={this.props.productTypeOptions}
        templateThemeOptions={this.props.templateThemeOptions} eventOptions={this.props.eventOptions} designerOptions={this.props.designerOptions} applyFillDown={this.applyFillDown}
        updateCurZip={this.updateCurZip} preApplyFillDown={this.preApplyFillDown} fullProductTypes={this.props.fullProductTypes} />;
    } else { var renderModal } //eslint-disable-line
    return (
      <div>
        <h1>Table of Zips</h1>
        {showProgress}

        <Button onClick={this.props.goBack} style={{marginRight: 8}}>Go Back to upload</Button>
        <Select
          showSearch
          style={{ width: 300 }}
          placeholder="Select Zip..."
          optionFilterProp="children"
          defaultValue={curZip}
          onChange={this.updateCurZipLoader}
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {this.props.merchZipFiles.map(zip => {
            return (
              <Option value={zip.value}>{zip.text}</Option>
            )
          })}
        </Select>
        <span style={{marginLeft: 8, marginRight: 8}}>Show only unfinished:</span><Switch onChange={this.props.switchAllZipFinishedInd} defaultChecked />
        {curZip !== undefined ? <Button type="danger" style={{marginLeft: 8}} onClick={this.deleteZipFile}>Delete zip</Button> : null}
        <Loader inline active={this.state.showLoader} style={{marginLeft: '5px'}} />
        <div style={{marginTop: '5px'}}>
        <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              ref="TableTwo"
              headerHeight={30}
              className={tableStyles}
              height={60}
              rowCount={numRowsTwo}
              rowGetter={({ index }) => currentSelectedZipFileData[index]}
              rowHeight={30}
              rowStyle={headerStyle}
              width={width}
              onRowClick={this.topRowClick.bind(this)}
            >
            <Column
              label='Zip File'
              dataKey='zipfile'
              width={360}
            />
            <Column
              width={150}
              label='Shirt Type'
              dataKey='shirttype_id'
              cellDataGetter={this.translateValue}
            />
            <Column
              width={150}
              label='Fit Type'
              dataKey='fittype'
            />
            <Column
              width={100}
              label='Colors'
              dataKey='colors'
            />
            <Column
              width={100}
              label='List Price'
              dataKey='listprice'
            />
            <Column
              width={150}
              label='Feature 1'
              dataKey='feature1'
            />
            <Column
              width={150}
              label='Feature 2'
              dataKey='feature2'
            />
            <Column
              width={250}
              label='Description'
              dataKey='description'
            />
            <Column
              width={125}
              label='Template Theme'
              dataKey='merchtemplatetheme_id'
              cellDataGetter={this.translateValue}
            />
            <Column
              width={100}
              label='Event'
              dataKey='merchcalendar_id'
              cellDataGetter={this.translateValue}
            />
            <Column
              width={100}
              label='Designer'
              dataKey='merchdesigner_id'
              cellDataGetter={this.translateValue}
            />
            </Table>
          )}
        </AutoSizer>
        </div>
        <div style={{marginTop: '10px'}}>
        <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              ref="Table"
              headerHeight={30}
              className={tableStyles}
              height={510}
              rowCount={numRows}
              rowGetter={({ index }) => currentSelectedZipFileQueue[index]}
              rowHeight={30}
              rowStyle={this.changeRowClass}
              width={width}
              onRowClick={this.bottomRowClick.bind(this)}
            >
            <Column
              label='Title'
              dataKey='title'
              width={360}
              cellRenderer={this.checkTitleLength}
            />
            <Column
              width={150}
              label='Shirt Type'
              dataKey='shirttype_id'
              cellDataGetter={this.translateValue}
            />
            <Column
              width={150}
              label='Fit Type'
              dataKey='fittype'
            />
            <Column
              width={100}
              label='Colors'
              dataKey='colors'
            />
            <Column
              width={100}
              label='List Price'
              dataKey='listprice'
            />
            <Column
              width={150}
              label='Feature 1'
              dataKey='feature1'
            />
            <Column
              width={150}
              label='Feature 2'
              dataKey='feature2'
            />
            <Column
              width={250}
              label='Description'
              dataKey='description'
            />
            <Column
              width={125}
              label='Template Theme'
              dataKey='merchtemplatetheme_id'
              cellDataGetter={this.translateValue}
            />
            <Column
              width={100}
              label='Event'
              dataKey='merchcalendar_id'
              cellDataGetter={this.translateValue}
            />
            <Column
              width={100}
              label='Designer'
              dataKey='merchdesigner_id'
              cellDataGetter={this.translateValue}
            />
            </Table>
          )}
        </AutoSizer>

        </div>
        {renderModal}
        {showModalProgress}
        </div>
    );
  }
}

export default Ziptable;



// WEBPACK FOOTER //
// ./src/pages/newtmptable.js